const createWorkerPromise = (Worker2, postMessage) => {
  return new Promise((resolve, reject) => {
    let worker = new Worker2();
    if (worker) {
      worker.onmessage = (e) => {
        var _a, _b;
        if (e.isTrusted) {
          ((_a = e.data) == null ? void 0 : _a.type) === "error" ? reject(e.data.error) : resolve((_b = e.data) == null ? void 0 : _b.data);
        }
        worker == null ? void 0 : worker.terminate();
      };
      worker.onerror = worker.onmessageerror = reject;
    }
    worker == null ? void 0 : worker.postMessage(postMessage);
  });
};
const encodedJs$1 = "KGZ1bmN0aW9uKCl7InVzZSBzdHJpY3QiO2NvbnN0IG49cz0+dHlwZW9mIHM9PSJmdW5jdGlvbiIscj1zPT5uZXcgRnVuY3Rpb24oYHJldHVybiAke2RlY29kZVVSSShzKX1gKSgpO3NlbGYuYWRkRXZlbnRMaXN0ZW5lcigibWVzc2FnZSIsYXN5bmMgcz0+e2lmKCFzLmlzVHJ1c3RlZClyZXR1cm47bGV0e2RhdGE6ZX09cyx0PShlPT1udWxsP3ZvaWQgMDplLmZuKSYmcihlLmZuKTtuKHQpP2UhPW51bGwmJmUucmF3RGF0YT9zZWxmLnBvc3RNZXNzYWdlKHt0eXBlOiJkYXRhIixkYXRhOnQoZS5yYXdEYXRhKX0pOnNlbGYucG9zdE1lc3NhZ2Uoe3R5cGU6ImVycm9yIixlcnJvcjoibm8gZGF0YSBwcm92aWRlZCJ9KTpzZWxmLnBvc3RNZXNzYWdlKHt0eXBlOiJlcnJvciIsZXJyb3I6Im5vIGZ1bmN0aW9uIHByb3ZpZGVkIn0pfSl9KSgpOwo=";
const blob$1 = typeof window !== "undefined" && window.Blob && new Blob([atob(encodedJs$1)], { type: "text/javascript;charset=utf-8" });
function WorkerWrapper$1() {
  const objURL = blob$1 && (window.URL || window.webkitURL).createObjectURL(blob$1);
  try {
    return objURL ? new Worker(objURL, {}) : new Worker("data:application/javascript;base64," + encodedJs$1, { type: "module" });
  } finally {
    objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
  }
}
const serializeFunction = (f) => encodeURI(f.toString());
const fnWorker = (fn, rawData) => {
  return createWorkerPromise(WorkerWrapper$1, { fn: serializeFunction(fn), rawData });
};
const encodedJs = "KGZ1bmN0aW9uKCl7InVzZSBzdHJpY3QiO2NvbnN0IG89cj0+dHlwZW9mIHI9PSJmdW5jdGlvbiIsZD1yPT5uZXcgRnVuY3Rpb24oYHJldHVybiAke2RlY29kZVVSSShyKX1gKSgpLHc9cj0+e3ZhciBlLHM7cmV0dXJuKHM9KGU9cj09bnVsbD92b2lkIDA6ci5tZXRob2QpPT1udWxsP3ZvaWQgMDplLnRvVXBwZXJDYXNlKCkpIT1udWxsP3M6IkdFVCJ9O2Z1bmN0aW9uKmYocil7Zm9yKGxldCBlPTA7ZTxyLmF0dGVtcHRzO2UrKyl5aWVsZCBuZXcgUHJvbWlzZShzPT5lPT09MD9zKHZvaWQgMCk6c2V0VGltZW91dChzLHIuZGVsYXkpKX1zZWxmLmFkZEV2ZW50TGlzdGVuZXIoIm1lc3NhZ2UiLGFzeW5jIHI9PntpZighci5pc1RydXN0ZWQpcmV0dXJuO2xldHtkYXRhOmV9PXIse3VybDpzLG9wdGlvbnM6aSxyZXRyeTpufT1lLHU9dyhpKTtpZigodT09PSJQT1NUInx8dT09PSJQVVQiKSYmKGU9PW51bGw/dm9pZCAwOmUucmVxdWVzdE1pZGRsZXdhcmUpKXtsZXQgYT1kKGUucmVxdWVzdE1pZGRsZXdhcmUpLHQ9aS5ib2R5O3QmJm8oYSkmJihpPXsuLi5pLGJvZHk6SlNPTi5zdHJpbmdpZnkoYShKU09OLnBhcnNlKHQpKSl9KX1jb25zdCBwPWFzeW5jKCk9Pnt2YXIgYTt0cnl7bGV0IHQ9YXdhaXQgZmV0Y2gocyxpKTtpZih0Lm9rJiZ0LnN0YXR1cyE9PTQwNCYmdC5zdGF0dXMhPT00MDMpe2xldCBjPWF3YWl0IHQuanNvbigpLHk9KGU9PW51bGw/dm9pZCAwOmUucmVzcG9uc2VNaWRkbGV3YXJlKSYmZChlLnJlc3BvbnNlTWlkZGxld2FyZSk7cmV0dXJuIG8oeSk/eShjKTpjfWVsc2UgdGhyb3cgbmV3IEVycm9yKGAkeyhhPXQuc3RhdHVzKSE9bnVsbD9hOnQuc3RhdHVzVGV4dH1gKX1jYXRjaCh0KXt0aHJvdyB0fX07bnx8KG49e2F0dGVtcHRzOjEsZGVsYXk6MH0pO2xldCBoPWYobiksbDtmb3IoOyFsOyl0cnl7bD1hd2FpdCBwKCksc2VsZi5wb3N0TWVzc2FnZSh7dHlwZToiZGF0YSIsZGF0YTpsfSl9Y2F0Y2goYSl7bGV0IHQ9aC5uZXh0KCk7dC5kb25lPyhsPSEwLHNlbGYucG9zdE1lc3NhZ2Uoe3R5cGU6ImVycm9yIixlcnJvcjphfSkpOmF3YWl0IHQudmFsdWV9fSl9KSgpOwo=";
const blob = typeof window !== "undefined" && window.Blob && new Blob([atob(encodedJs)], { type: "text/javascript;charset=utf-8" });
function WorkerWrapper() {
  const objURL = blob && (window.URL || window.webkitURL).createObjectURL(blob);
  try {
    return objURL ? new Worker(objURL, {}) : new Worker("data:application/javascript;base64," + encodedJs, { type: "module" });
  } finally {
    objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
  }
}
const fetchWorker = ({ url, requestMiddleware, responseMiddleware, options, retry }) => {
  return createWorkerPromise(WorkerWrapper, {
    url,
    options,
    requestMiddleware: requestMiddleware && serializeFunction(requestMiddleware),
    responseMiddleware: responseMiddleware && serializeFunction(responseMiddleware),
    retry
  });
};
export { fetchWorker, fnWorker };
